import { useCallback, useMemo, useState } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { PersonalContactsDialog } from './PersonalContactsDialog';

export const usePersonalContactsDialog = () => {
  const [open, setOpen] = useState(false);
  const [entity, setEntity] = useState<Entities>(null);
  const [sdObjMemberId, setSdObjMemberId] = useState<number>(null);

  const toggleDialog = useCallback(
    (entity: Entities, sdObjMemberId: number, contactId?: number) => {
      setEntity(entity);
      setSdObjMemberId(sdObjMemberId);
      setOpen(true);
    },
    []
  );

  const dialog = useMemo(
    () => (
      <PersonalContactsDialog
        open={open}
        onClose={() => setOpen(false)}
        entity={entity}
        sdObjMemberId={sdObjMemberId}
      />
    ),
    [open, entity, sdObjMemberId]
  );
  return {
    dialog,
    toggleDialog,
  };
};
